export const ADS_APP_ID = 'numbernode';
export const ADS_MIN_WIDTH = 1280;
export const ADS_ENABLED = import.meta.env.VITE_NUMBERNODE_ADS_ENABLED !== '0';
export const ADS_MANAGER_ORIGIN = import.meta.env.VITE_NUMBERNODE_ADS_MANAGER_ORIGIN || 'https://ads.picplayer.com';
export const ADS_FRAME_ORIGIN = import.meta.env.VITE_NUMBERNODE_ADS_FRAME_ORIGIN || 'https://frames.picplayer.com';
